import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

function useNutritionExists(itemId: string) {
    const { data } = useQuery({
        ...queries.items.nutrition(itemId),
        retry: 2,
    });
    return useMemo(() => {
        if (data) {
            const keys = Object.keys(data);
            for (let i = 0; i < keys.length; i += 1) {
                // @ts-ignore
                if (data[keys[i]]) {
                    return true;
                }
            }
        }
        return false;
    }, [data]);
}

export default useNutritionExists;
